import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Svg = styled.svg`
  width: ${(props) => props.s.width || '1rem'};
  height: ${(props) => props.s.height || 'auto'};
  fill: ${(props) => props.s.fill || '#000'};
`;

const Close = ({ s, className }) => (
  <Svg s={s} className={className} viewBox="0 0 10 10">
    <path d="M9 1.8L8.2 1 5 4.2 1.8 1l-.8.8L4.2 5 1 8.2l.8.8L5 5.8 8.2 9l.8-.8L5.8 5" />
  </Svg>
);

Close.defaultProps = {
  className: null,
  s: {},
};

Close.propTypes = {
  className: PropTypes.string,
  s: PropTypes.shape({
    width: PropTypes.string,
    height: PropTypes.string,
    fill: PropTypes.string,
  }),
};

export default Close;
